/**
 * UserProfileImageCropper Component
 * Handles image upload and cropping for user profile pictures
 */

import React from "react";
import Modal from "react-modal";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const UserProfileImageCropper = ({
  isOpen,
  image,
  cropperRef,
  onCrop,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Image Crop Modal"
      style={{
        content: {
          height: "500%",
          width: "1000%",
          position: "fixed",
          top: "15%",
          left: "50%",
          parent: document.querySelector(".admin-outer.time.tracker"),
        },
      }}
    >
      <div>
        {image && (
          <Cropper
            ref={cropperRef}
            style={{ height: 400, width: "100%" }}
            zoomTo={0}
            initialAspectRatio={1}
            preview=".img-preview"
            src={image}
            viewMode={1}
            minCropBoxHeight={10}
            minCropBoxWidth={10}
            background={false}
            responsive={true}
            autoCropArea={100}
            checkOrientation={false}
            guides={true}
          />
        )}
      </div>
      <div>
        <div className="crop-btn">
          <button onClick={onCrop}>Crop and Upload</button>
          <button className="delete-client" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </Modal>
  );
};

export default UserProfileImageCropper;
